<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_2)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_2" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescriptionNo(item.description_no_3)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_3)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_3" alt="Content Image" class="image" />
              </div> 
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section (moved to the right) -->
      <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: 暂无(E-mail Only)</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
        <!-- Add more contact info as needed -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/PlanandCases/DigitalAssets/BeijiaoDigitalMuseumPage/BeijiaoDigitalMuseumPageimg1.jpg"),
            image_2: require("@/assets/img/PlanandCases/DigitalAssets/BeijiaoDigitalMuseumPage/BeijiaoDigitalMuseumPageimg2.jpg"),
            image_3: require("@/assets/img/PlanandCases/DigitalAssets/BeijiaoDigitalMuseumPage/BeijiaoPictureWallOpacity.png"),
            title: "云翰虹章团队助力北京交通大学数字博物馆搭建",
            description_no_1:`
            <strong class="bold-text">1. 案例简介</strong>
            `,
            description_1:`
            北京交通大学的历史可追溯到清政府创办的铁路管理传习所，同时作为国内交通大学的三个源头之一，它见证了中国铁路与交通的发展。该大学的运输设备教学馆中藏有600余件见证了我国铁路发展历程的铁路运输设备的实物、模型，图片与视频资料。

            2023年7月，因该博物馆需要搬迁，所以北京交通大学交通运输学院希望在此期间记录展品的相关信息并进行建模，并建立一个数字博物馆。在此背景下，云翰虹章接触到了这个项目，并在搬迁期间完成了所有展品的扫描与数字博物馆的搭建。
            `,
            description_no_2: `
              <strong class="bold-text">2. 挑战与解决方案</strong>
              `,
            description_2: ` 
            在项目的初期，学院方遭遇了种种挑战：模型数据的采集时间短而精度要求高，但他们缺乏建模与编程方面的人才，无法独立完成数字博物馆的搭建。同时该项目工期紧、任务重，他们迫切希望寻找到合适的团队来帮助他们进行数字博物馆的搭建，而云翰虹章团队正是在此背景下接手了此项目。

            我们团队在参与该项目的途中遇到了两个方面的困难：一方面，学院方缺乏相关技术人才，因此难以为我们提供技术上的支持；另一方面，博物馆中的多数展品是具有大量机械结构和复杂表面的非标准模型，且在搬迁过程中无法为我们提供精确的扫描数据，这就为相关数据的采集带来了额外的困难。为了面对这些挑战，云翰虹章给出了独特的答案，也就是结合正向建模与逆向建模的方案。

            正向建模，即先利用绘图或建模等手段预先做出产品设计原型，然后根据原型制造产品；而逆向建模则恰好相反，先通过采集实物的大量三维坐标来获取几何模型，进而进行产品制作。由于逆向建模主要用于建设简单部件，同时正向建模的人力消耗过大，所以我们首先拍摄了所有博物馆展品的视频，并进行逆向建模的尝试。与此同时，对于那些逆向建模无法处理的复杂物品，我们则集中人力进行正向建模。
            `,
            description_no_3: `
            <strong class="bold-text">3. 成果</strong>
            `,
            description_3:`
            在此次项目中，云翰虹章成功以教学用具的标准为北京交通大学运输设备教学馆的每一个展品建模。整体而言，这次案例分析让我们对3D建模有了更深入的认识，同时这些成果不仅对我们自己的研究有着重要的意义，也为公司在建模领域的发展提供了新的视角和启示。

            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/PlanandCases/DigitalAssets/BeijiaoDigitalMuseumPage/BeijiaoDigitalMuseumPageimg1.jpg"),
            image_2: require("@/assets/img/PlanandCases/DigitalAssets/BeijiaoDigitalMuseumPage/BeijiaoDigitalMuseumPageimg2.jpg"),
            image_3: require("@/assets/img/PlanandCases/DigitalAssets/BeijiaoDigitalMuseumPage/BeijiaoPictureWallOpacity.png"),
            title: "Beijing Jiaotong University's Digital Museum",
            description_no_1:`
            <strong class="bold-text">1. Intro</strong>
            `,
            description_1:`
            The history of Beijing Jiaotong University can be traced back to the Railway Management Institute founded by the Qing government, and as one of the three sources of transport universities in China, it has witnessed the development of China's railways and transport. The University's Transport Equipment Teaching Hall contains more than 600 pieces of railway transport equipment that have witnessed the development of China's railways, including objects, models, pictures and video materials.

            In July 2023, the museum needs to be relocated, so the School of Transportation and Communications of Beijing Jiaotong University wants to record and model information about the exhibits and build a digital museum in the meantime. Rosy Nebula approached the project and completed the scanning of all the exhibits and the building of the digital museum during the relocation period.
            `,
            description_no_2: `
              <strong class="bold-text">2. Challenges and solutions</strong>
              `,
            description_2: ` 
            In the early stage of the project, the academy encountered various challenges: the collection time of model data was short and the accuracy requirement was high, but they lacked talents in modelling and programming, and could not complete the construction of the digital museum independently. The Rosy Nebula team took over the project against the backdrop of a tight deadline and a heavy workload, and they were eager to find a suitable team to help them build the digital museum.

            Our team encountered two difficulties on the way to participate in the project: on the one hand, the academy lacked relevant technical talents, so it was difficult to provide us with technical support; on the other hand, most of the exhibits in the museum were non-standard models with a large number of mechanical structures and complex surfaces, and they were unable to provide us with accurate scanning data during the process of moving, which brought additional difficulties in the collection of relevant data. difficulties. In order to face these challenges, Rosy Nebula provided a unique answer, which is a combination of forward modelling and reverse modelling.

            Forward modelling, in which a prototype of a product design is made in advance using drawing or modelling, and then the product is manufactured according to the prototype, and reverse modelling, in which a geometric model is first obtained by capturing a large number of 3D coordinates of the physical object, and then the product is manufactured, are the exact opposite of this. Since reverse modelling is mainly used for building simple parts, and at the same time the manpower consumption of forward modelling is too large, we firstly shot videos of all the museum exhibits and made attempts of reverse modelling. Meanwhile, for those complex items that cannot be handled by reverse modelling, we focused our manpower on forward modelling.
            `,
            description_no_3: `
            <strong class="bold-text">3.Achievements</strong>
            `,
            description_3:`
            In this project, Rosy Nebula successfully modelled every exhibit in the Transportation Equipment Teaching Hall of Beijing Jiaotong University to the standard of a teaching aid. Overall, this case study has given us a deeper understanding of 3D modelling, while the results are not only of great significance to our own research, but also provide new perspectives and insights for the company's development in the modelling field.

            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
